import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import cookie from 'lib/cookie'
import { isCallInUse } from 'lib/conferenceCall'

import { useLeaveCallMutation } from 'store/api/yay/call'
import { selectIsLoggedIn } from 'store/selectors'
import { LocalStorage } from 'lib/storage'
import { isNil } from 'lodash'
import { removeRTMToken } from 'store/slices/agora'

// todo: revise this logic
// the zombie call is a call that use close by force close browser, didn't close by clicking close button
const useClearZombieConferenceCall = () => {
  const dispatch = useDispatch()
  const isLoggedIn = useSelector(selectIsLoggedIn)
  const [leaveCall] = useLeaveCallMutation()

  useEffect(() => {
    const i = setInterval(async () => {
      const willLeaveConferenceId = LocalStorage.willLeaveConferenceId.get(null)

      if (!isNil(willLeaveConferenceId) && !isCallInUse()) {
        try {
          await leaveCall({
            conferenceId: willLeaveConferenceId,
            chatUuid: cookie.chatUuid.get(),
            duration: +LocalStorage.callDuration.get(0),
            totalUsersInCall: +LocalStorage.callTotalUsers.get(0),
          })
        } finally {
          LocalStorage.willLeaveConferenceId.remove()
          LocalStorage.callDuration.remove()
          LocalStorage.callTotalUsers.remove()
          dispatch(removeRTMToken())
          cookie.chatUuid.remove()
        }
      }
    }, 5000)

    return () => {
      clearInterval(i)
    }
  }, [isLoggedIn])
}

export default useClearZombieConferenceCall
